

























































































import {
  computed,
  defineComponent,
  reactive,
  ref,
} from '@vue/composition-api';
import type { Ref } from '@vue/composition-api';

import vehicles from '@/table/deliveryNote/vehicle';
import useAuth from '@/useAuth';

import getVehicles from '@/gql/vehicle/getVehiclesForSelectModal.gql';

const CommonModalWithVehicleSelector = defineComponent({
  props: {
    filterDate: {},
    variables: { default: () => ({}) },
    enableFilterReservedOnly: { default: true },
  },
  setup(props, { emit }) {
    const { me } = useAuth();
    const modal = ref(null);
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const filter = reactive({
      search: '',
      filterByReservedOnly: '',
      vehicleType: '',
    });

    const filterVehicleDisplay = ['ลำดับการสร้าง', 'แก้ไขข้อมูลล่าสุด', 'ชื่อ'];
    const filterVehicleList = ['createdAt', 'updatedAt', 'name'];
    const selectedFilterVehicle = ref('createdAt');

    const vehiclesVariable = computed(() => {
      const OR = [];
      // eslint-disable-next-line
      let filterByReservedOnly: undefined | boolean = undefined;

      if (filter.search !== '') {
        OR.push({ column: 'LICENSE', operator: 'LIKE', value: `%${filter.search}%` });
        OR.push({ column: 'MODEL', operator: 'LIKE', value: `%${filter.search}%` });
      }
      if (filter.filterByReservedOnly !== '') {
        filterByReservedOnly = (filter.filterByReservedOnly === 'true' || filter.filterByReservedOnly === true as any);
      }
      if (filter.vehicleType !== '') {
        OR.push({ column: 'VEHICLE_TYPE', value: filter.vehicleType });
      }

      const vars: {[key: string]: any} = {
        first: 6,
        filter: {
          OR,
        },
        filterByReservedOnly,
        filterFreeDate: props.filterDate ? props.filterDate : undefined,
        ...props.variables,
      };
      return vars;
    });
    function open(ctx: any) {
      if (ctx.filter.filterByReservedOnly) filter.filterByReservedOnly = ctx.filter.filterByReservedOnly;
      if (ctx.filter.vehicleType) filter.vehicleType = ctx.filter.vehicleType;
      (modal.value as any).open();
    }
    function close() { (modal.value as any).close(); }
    const getVehiclesResult = (data: any) => (data.vehicles);

    function getRecentMonthCashFlow(cashFlowArr: any[]) {
      for (let i = 0; i < cashFlowArr.length; i += 1) {
        if (cashFlowArr[i].month === (new Date()).getMonth() + 1) return cashFlowArr[i].sum;
      }
      return 0;
    }

    const selectedVehicle: Ref<any> = ref({
      id: -1,
      license: '',
      avatarUrl: '',
      minWeight: 0,
      maxWeight: 0,
      defaultDriver: undefined,
    });
    const selectVehicle = (row: any) => {
      selectedVehicle.value = { ...row.item };
    };
    const clearVehicle = () => {
      selectedVehicle.value.id = -1;
    };

    function confirmVehicle() {
      emit('selectVehicle', { ...selectedVehicle.value });
      close();
      clearVehicle();
    }

    return {
      me,
      modal,
      open,
      close,
      toCurrency,
      filter,

      getVehicles,
      vehiclesVariable,
      getVehiclesResult,
      vehiclesOption: vehicles,

      selectedVehicle,
      selectVehicle,

      selectedFilterVehicle,
      vehicles,

      confirmVehicle,
      clearVehicle,
    };
  },
});

export default CommonModalWithVehicleSelector;
